import ABCyaPhaser from "@abcya/abcya_phaser";
import AScene from "../../library/ExtendedObjects/AScene.js";
import FontKeys from "../../FontKeys.js";

export default class PauseMenu extends AScene
{
    static get KEY() { return 'RestartPopUp'; }
    create()
        {
            this.PauseBackDrop = this.add.rectangle(0,0,1024,768,'#333840',.3);
            this.PauseBackDrop.setOrigin(0,0);

            const MenuBack = this.add.container(683,this.mid.y);
            const MenuBackDrop = this.addImage(0,0, 'Menus_Popups/Restart');
            const MenuText = ABCyaPhaser.Text.addText(0, -78, 52, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('are_you_sure'), this);
            MenuText.setShadow(-3, 2, '#f58820', 0, true, true);

            MenuBack.add([MenuBackDrop, MenuText]);
            const MenuBounds = MenuBack.getBounds();

            const YesButton = this.add.container(MenuBounds.left+130, MenuBounds.bottom-100);
            const YesButtonBack = this.addButton(0,0, 'Menus_Popups/Yes');
            const YesButtonText = ABCyaPhaser.Text.addText(0, 0, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('yes'), this).setPadding(0,3,3);
            YesButtonText.setShadow(-2, 0, '#f58820', 0, true, true);

            YesButton.add([YesButtonBack, YesButtonText]);

            const NoButton = this.add.container(MenuBounds.right-130,MenuBounds.bottom-100);
            const NoButtonBack = this.addButton(0,0, 'Menus_Popups/No');
            const NoButtonText = ABCyaPhaser.Text.addText(0, 0, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('no'), this);
            NoButtonText.setShadow(-2, 0, '#f58820', 0, true, true);

            NoButton.add([NoButtonBack, NoButtonText]);

            var SendData = {Action: "null"};

            const Buttons = [YesButtonBack,NoButtonBack];

            for(let x in Buttons)
            {
                Buttons[x].setOrigin(.5,.5);
            }

            NoButtonBack.once('pointerdown',()=>{
                this.scene.resume('PlaceItems',SendData);
                this.playSound('button_menu_click');
                this.scene.stop();
            });

            YesButtonBack.once('pointerdown',()=>{
                SendData.Action = "New";
                this.playSound('button_menu_click');
                this.scene.resume('PlaceItems',SendData);
                this.scene.stop();
            });
        }
}